
export class BaseVo{
  $data=null;
  convert(data){
    this.$data = data;
  }
}



// WEBPACK FOOTER //
// ./src/vo/baseVo.js